<template>
  <div id="app">
    <!-- <keep-alive> -->
    <!-- 缓存所有的页面 -->
    <keep-alive :include="keepAlive">
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <!-- </keep-alive> -->
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    keepAlive() {
      return this.$store.getters.keepAlive
    }
  },
  created() {
    console.log('打开app')
    console.log(process.env)
    this.$store.commit('SET_ISPC', this.isPC())
  },
  mounted() {
    window.addEventListener('beforeunload', (e) => this.beforeunloadHandler())
  },
  methods: {
    isPC() {
      var userAgentInfo = navigator.userAgent.toLowerCase()
      var Agents = [
        'android',
        'iphone',
        'symbianos',
        'windows phone',
        'ipad',
        'ipod'
      ]
      var flag = true
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false
          break
        }
      }
      return flag
    },
    beforeunloadHandler() {
      console.log('关闭app')
    }
  }
}
</script>

<style lang="scss">
[v-cloak] {
  display: none;
}
@import '@/assets/styles/common.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue